<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout align-center row>
      <v-spacer />

      <router-link
        v-if="hasRole('profiles', 'ROLE_ADMINISTRATOR')"
        :to="{
          name: 'CompanyGroup',
          params: { type: 'cadastrar' }
        }"
        class="action-bar__link"
      >
        {{ $t(`${namespace}.createCompanyGroup`) }}
      </router-link>

      <v-btn
        v-if="hasRole('profiles', 'ROLE_ADMINISTRATOR')"
        :to="{ name: 'CreateCompany' }"
        color="accent"
        class="action-bar__btn"
        round
        depressed
      >
        {{ $t(`${namespace}.newCompany`) }}
      </v-btn>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.CompanyPage.actionBar',
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'Company', title: this.$t('Views.CompanyPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>
